import React from "react";
import UserEvent from "./constants/user-event";
import EcomStep from "./constants/ecom-step";
export default (props) => {
    const handleExitClick = () => {
        const isExitCancellation = props.step !== EcomStep.FINAL_CONFIRMATION;
        if (isExitCancellation) {
            props.onIncompleteUserEvent(UserEvent.ORDER_CANCELLED);
        }
        props.onExit();
    };
    const handleBackClick = () => {
        props.onIncompleteUserEvent(UserEvent.BACK_BUTTON_CLICKED);
        props.onPreviousStepClick();
    };
    return (React.createElement("header", { "data-ecom-header": "" },
        React.createElement("div", { className: "header" },
            React.createElement("div", { className: "header-action" }, props.canPressBackButton && (React.createElement("button", { "data-ecom-link": "", title: "Tillbaka", onClick: handleBackClick },
                React.createElement("i", { className: "icon-chevron-left m-r-half" }),
                "Tillbaka"))),
            React.createElement("div", { className: "header-logo-container" },
                React.createElement("img", { src: props.serviceLogotypeUrl, alt: "Logotype", className: "header-logo" })),
            React.createElement("div", { className: "header-action" },
                React.createElement("button", { className: "header-action-btn", title: "St\u00E4ng", onClick: handleExitClick },
                    React.createElement("i", { className: "icon-close no-margin" }))))));
};
